<template>
  <form-section class="device-container">
    <div class="image-box">
      <div class="image-container">
        <el-image :src="appImageSrc" lazy />
      </div>
    </div>
  </form-section>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
export default {
  name: 'DeviceApplicationImageCard',

  components: {
    FormSection
  },

  props: {
    appImageSrc: {
      required: true
    }
  }
}
</script>

<style scoped>
.device-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-box {
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-container img {
  max-width: 500px;
  max-height: 170px;
}
</style>



// WEBPACK FOOTER //
// src/modules/devices/components/DeviceApplicationImageCard.vue